// Strings + choices for the ET export window (ExportWindow.jsx).

export const EXPORT_TEXT = {
  TITLE_ONE: 'Export 1 clip',
  titleMany: (n) => `Export ${n} clips`,
  NAME: 'Title',
  NAME_PLACEHOLDER: 'Leave blank to use the transcript title',
  WHAT: 'What you get',
  WHAT_HINT: 'tick one or more · scroll for more',
  SHAPE: 'Shape',
  CAPTIONS: 'Captions on the video',
  CAPTIONS_HINT: 'Burned in, timed to every word',
  COLORS: 'Colors',
  FONT: 'Font',
  SIZE: 'Size',
  STYLE: 'Style',
  HIGHLIGHT: 'Highlight',
  APPEAR: 'Words appear',
  BOUNCE: 'Bounce',
  SHARPNESS: 'Sharpness',
  TRANSITIONS: 'Transitions',
  TRANSITIONS_HINT: 'How the video starts, and between your clips',
  START: 'Start',
  BETWEEN: 'Between clips',
  BETWEEN_OFF: 'when clips are stitched into one video',
  CAPS: 'ALL CAPS',
  WORDS_PER_GROUP: 'Words per group',
  PREVIEW: 'Preview',
  PREVIEW_NOTHING: 'nothing picked',
  YOU_GET: "You'll get",
  PICK_ONE: 'Pick at least one thing to make.',
  LANDS: 'Lands in My Library → Exported.',
  LONG: 'over 5 minutes, so it takes longer',
  CLOSE: 'Close',
  EXPORT: 'Export',
  exportFiles: (n) => `Export ${n} files`,
  exportOne: (ext) => `Export ${ext}`,
  NEEDS_CLIPS: 'Tick some clips first',
  NEEDS_SEARCH: 'Combine searched words · search one first',
  gifLimit: (seconds) => `Only for clips up to ${seconds} seconds`,
  AUDIO_ONLY: 'Sound only · no picture',
  XML_HINT: 'Opens as a new sequence in Premiere Pro',
  xmlFoot: (n) => `V1 · ${n} clip${n === 1 ? '' : 's'} cut from your original file · A1 · their sound`,
  ZIP_MORE: 'whole video · every speaker and emotion',
  ZIP_FOOT: '… + the same as Premiere .xml sequences, for every speaker',
  GIF_BADGE: 'GIF · no sound',
  LOGO_ALT: 'CherryClipz',
  MORE_BELOW: 'More options',
  SHARE_LINK: 'Share this spreadsheet',
  COPY_LINK: 'Copy',
  COPIED: 'Copied ✓',
  OPEN_LINK: 'Open',
  HIDE_LINK: 'Hide the link',
  EDIT_WORDS: '✏ Edit words',
  EDIT_WORDS_LABEL: 'The words of this clip',
  EDIT_HINT: 'Changes this clip in your spreadsheet too · Enter saves',
  EDIT_SAVE: 'Save',
  EDIT_CANCEL: 'Cancel',
  EDIT_RESET: 'Back to what was said',
  PICKS: 'Your cherry picks',
  PICKS_HINT: 'in the order they come out · click one to preview it',
  HOW: 'How',
  STITCHED: 'Stitched into one video',
  SEPARATE: 'Each clip its own video',
  exportVideos: (n) => `Export ${n} videos`,
  videosCount: (n) => `${n} separate videos`,
  SHARE_LINK_HINT: 'A link to this whole CherryClipz spreadsheet (not a video) — anyone with it can open the clips',
  PREMIERE_PANEL: 'Working in Premiere? Get the plugin',
  // My Style — the saved look every export uses (export window, Ready-to-post, Claude, ChatGPT)
  SAVE_STYLE: 'Save as my style',
  STYLE_HINT: 'Captions, shape and transitions for every export: here, Ready-to-post, Claude and ChatGPT.',
  STYLE_IN_USE: 'Opened with your saved style.',
  STYLE_SAVED: 'Saved. Ready-to-post, Claude and ChatGPT use it now.',
  STYLE_SAVE_FAILED: "Couldn't save your style. Try again.",
  // Your logo (part of My Style)
  LOGO: 'Your logo',
  LOGO_HINT: 'A PNG with a see-through background works best. Drag it on the preview to place it.',
  LOGO_UPLOAD: 'Upload logo',
  LOGO_REPLACE: 'Replace',
  LOGO_REMOVE: 'Remove',
  LOGO_SIZE: 'Size',
  LOGO_OPACITY: 'Strength',
  LOGO_UPLOADING: 'Uploading…',
  LOGO_FAILED: "Couldn't use that image. Try a PNG under 4 MB.",
  LOGO_SAVE_REMINDER: 'Press Save as my style to put it on every export.',
  LOGO_PLACE: 'Place',
  LOGO_ON_PICTURE: 'On the picture',
  LOGO_ON_FRAME: 'In the frame',
  LOGO_BACKDROP: 'Backdrop',
  DRAG_HINT: 'Drag to move · double-click to re-center',
  SUPERCUT: 'Super Cut handles',
  SUPERCUT_HINT: 'Off = exact word cuts. Add breathing room if words sound clipped.',
  SUPERCUT_PAD: 'Breathing room',
  supercutPad: (ms) => `${ms} ms before and after each word`,
  ROOM: 'Breathing room',
  ROOM_HINT: 'Extra time before and after each clip — add some if words sound clipped.',
  ROOM_ADD: 'Add time',
  roomPad: (ms, alsoWords) => (alsoWords ? `${ms} ms around each word and each clip` : `${ms} ms before and after each clip`),
  roomDetail: (ms) => `+${ms} ms breathing room`,
  GAP_MENU: 'Transition between these two clips',
  GAP_OFF: 'Transitions join clips stitched into one video',
  MIXED_BETWEEN: 'your own transition at each join',
  PLAY_CLIP: '▶ Play clip',
  STOP_CLIP: '■ Stop',
  PLAY_CLIP_HINT: 'Play this clip in the preview, with its captions',
  SUPERCUT_EQUALIZE: 'Same length as the longest word',
  SUPERCUT_EQUALIZE_HINT: 'Every cut grows to match the slowest, clearest one — may catch a bit of the next word',
  FRAMING: 'Framing',
  FRAMING_HINT: 'drag the picture or the captions to place them on this clip',
  ZOOM: 'Zoom',
  zoomLabel: (z) => `${z.toFixed(1)}×`,
  FACE: 'Center on face',
  FACE_HINT: 'The export finds the speaker and frames this clip on them',
  FACE_BADGE: '🎯 auto: centers on the face',
  COPY_NEXT: 'Copy to next',
  APPLY_ALL: 'Copy to all',
  RESET_CLIP: 'Reset clip',
  RESET_ALL: 'Reset all',
  COPY_WHAT: 'Copy',
  COPY_PICTURE: 'Picture framing',
  COPY_CAPTIONS: 'Caption position',
  COPY_CAPTIONS_OFF: 'Turn captions on to place them',
  FRAMED_MARK: 'Custom framing',
  clipOf: (i, n) => `Clip ${i} of ${n}`,
  // Caption style picker (captionPresets.js)
  CAPTION_STYLE: 'Caption style',
  CAPTION_STYLE_HINT: 'Pick a look, then change its font, colors or size',
  ALL_STYLES: 'See all styles',
  OWN_STYLE: 'Your own',
  OWN_STYLE_HINT: 'Your own mix of the choices below.',
  STYLES_TITLE: 'Caption styles',
  STYLES_SUB: 'Each one plays your clip. Click one to use it.',
};

/** The toolbar option name for the text transcript (built in the browser, see transcriptText.js). */
export const TRANSCRIPT_OPTION = 'Create a transcript (TXT)';

const AUDIO_EXTS = ['MP3', 'M4A', 'WAV', 'AAC', 'FLAC', 'OGG', 'OGA', 'AIFF', 'AIF', 'WMA'];

/**
 * Turn one of the toolbar's export option names into a card. The names are the ones
 * draggableToolbar builds (`Create a MOV video`, 'Create a GIF', …) — the card keeps
 * the name so ticking it still calls onOptionChange(name) exactly as before.
 */
export const describeOption = (name) => {
  const video = /^Create a (\w+) video$/.exec(name);
  if (video) {
    const ext = video[1].toUpperCase();
    if (AUDIO_EXTS.includes(ext)) {
      // An audio upload's "video" is the audiogram: its sound over black + the cherry.
      return { key: 'audiogram', label: 'Video', ext: 'MP4', desc: 'The sound over a black screen and the cherry', video: true, caps: true };
    }
    return { key: 'video', label: 'Video', ext, desc: 'Your clips joined into one video', video: true, caps: true };
  }
  if (name.startsWith('Super Cut')) return { key: 'super', label: 'Super Cut', ext: 'MP4', desc: 'Combine your searched words, back to back', video: true, caps: true };
  if (name === 'Create an Audio + Logo video') return { key: 'audiogram', label: 'Audio + logo', ext: 'MP4', desc: 'The sound over a black screen and the cherry', video: true, caps: true };
  if (name === 'Create a MP3 audio') return { key: 'mp3', label: 'Audio', ext: 'MP3', desc: 'Just the sound', video: false, caps: false };
  if (name === 'Create a GIF') return { key: 'gif', label: 'GIF', ext: 'GIF', desc: 'A short silent loop', video: false, caps: false };
  if (name === 'Create a SRT file') return { key: 'srt', label: 'Subtitles', ext: 'SRT', desc: 'Timed text for YouTube or Premiere', video: false, caps: false };
  if (name === 'Create a VTT file') return { key: 'vtt', label: 'Web subtitles', ext: 'VTT', desc: 'Timed text for web players', video: false, caps: false };
  if (name === 'Export XML for Premiere Pro') return { key: 'xml', label: 'Premiere Pro', ext: 'XML', desc: 'Opens as a sequence in Premiere', video: false, caps: false };
  if (name === TRANSCRIPT_OPTION) return { key: 'txt', label: 'Transcript', ext: 'TXT', desc: 'The words as a text document, with speakers and times', video: false, caps: false };
  if (name.startsWith('Create zip file')) return { key: 'zip', label: 'Subtitle layers', ext: 'ZIP', desc: 'Whole video: an SRT + Premiere sequence per speaker and per emotion', video: false, caps: false };
  return { key: name, label: name, ext: '', desc: '', video: false, caps: false };
};

/** Shape cards → the worker's `orientation` value. */
export const SHAPES = [
  { key: 'original', orientation: 'original', label: 'Original', hint: 'as it was filmed', vertical: false },
  { key: 'landscape', orientation: 'landscape', label: 'Wide 16:9', hint: 'YouTube, TV', vertical: false },
  { key: 'blur', orientation: 'vertical', label: 'Vertical · Blur', hint: 'whole picture', vertical: true },
  { key: 'zoom', orientation: 'vertical_fill', label: 'Vertical · Zoom', hint: 'fills the screen', vertical: true },
];

export const SHAPE_DETAIL = {
  original: 'its own shape',
  landscape: '1920×1080 wide',
  blur: '1080×1920 vertical, blurred fill',
  zoom: '1080×1920 vertical, zoomed to fill',
};

export const CAPTION_MODES = [
  { key: 'word', label: 'One word', detail: 'one-word captions' },
  { key: 'group', label: 'Word groups', detail: 'word-group captions' },
  { key: 'sentence', label: 'Full sentence', detail: 'full-sentence captions' },
];

/** Same keys + colours as the worker's CAPTION_PALETTES and the phone app. */
export const CAPTION_PALETTES = [
  { key: 'cherry', label: 'White & cherry', base: '#FFFFFF', active: '#EC2B57' },
  { key: 'allcherry', label: 'All cherry', base: '#EC2B57', active: '#FFFFFF' },
  { key: 'white', label: 'All white', base: '#FFFFFF', active: '#FFFFFF' },
  { key: 'yellow', label: 'White & yellow', base: '#FFFFFF', active: '#FFE000' },
  { key: 'green', label: 'White & green', base: '#FFFFFF', active: '#39E75F' },
  { key: 'blue', label: 'White & blue', base: '#FFFFFF', active: '#2EA8FF' },
  { key: 'purple', label: 'White & purple', base: '#FFFFFF', active: '#B26BFF' },
  { key: 'orange', label: 'White & orange', base: '#FFFFFF', active: '#FF8A1F' },
  { key: 'allyellow', label: 'All yellow', base: '#FFE000', active: '#FFFFFF' },
  { key: 'violet', label: 'White & violet', base: '#FFFFFF', active: '#7B3FE4' },
  { key: 'lime', label: 'White & lime', base: '#FFFFFF', active: '#C6FF3A' },
];

/** The phone app's four caption fonts (mobile/captions.js) + seven social-caption fonts. The
 *  worker ships the same files (transcript/assets/fonts), so the key sent is the font that
 *  gets burned; the preview loads them from Google Fonts (CAPTION_FONTS_CSS). One-weight
 *  fonts are drawn at their own weight (400) on both sides — never a faked bold.
 *  scale: how big the worker's libass draws the font compared with the browser at the same
 *  size (libass sizes by the font's whole line height, usWinAscent+usWinDescent, the browser
 *  by its em) — MEASURED by rendering a capital H in the worker, 2026-10-06. */
export const CAPTION_FONTS = [
  { key: 'heavy', label: 'Heavy', css: '"Roboto Black", Roboto, "Arial Black", system-ui, sans-serif', weight: 900, scale: 0.83 },
  { key: 'plain', label: 'Plain', css: 'Roboto, system-ui, -apple-system, sans-serif', weight: 700, scale: 0.83 },
  { key: 'condensed', label: 'Condensed', css: '"Roboto Condensed", "Arial Narrow", system-ui, sans-serif', weight: 700, scale: 0.83 },
  { key: 'serif', label: 'Serif', css: '"Noto Serif", Georgia, serif', weight: 700, scale: 0.686 },
  { key: 'montblack', label: 'Montserrat', css: 'Montserrat, system-ui, sans-serif', weight: 900, scale: 0.643 },
  { key: 'poppinsblack', label: 'Poppins', css: 'Poppins, system-ui, sans-serif', weight: 900, scale: 0.568 },
  { key: 'anton', label: 'Anton', css: 'Anton, Impact, sans-serif', weight: 400, scale: 0.576 },
  { key: 'bebas', label: 'Bebas', css: '"Bebas Neue", Impact, sans-serif', weight: 400, scale: 0.771 },
  { key: 'bangers', label: 'Bangers', css: 'Bangers, Impact, sans-serif', weight: 400, scale: 0.589 },
  { key: 'luckiest', label: 'Luckiest', css: '"Luckiest Guy", Impact, sans-serif', weight: 400, scale: 0.841 },
  { key: 'marker', label: 'Marker', css: '"Permanent Marker", cursive', weight: 400, scale: 0.709 },
  // added 2026-10-16 with the key-word caption styles (scale = upm / (winAscent + winDescent))
  { key: 'playfair', label: 'Playfair', css: '"Playfair Display", Georgia, serif', weight: 800, italic: true, scale: 0.709 },
  { key: 'plexmono', label: 'Mono', css: '"IBM Plex Mono", ui-monospace, monospace', weight: 600, scale: 0.769 },
  { key: 'light', label: 'Light', css: 'Roboto, system-ui, -apple-system, sans-serif', weight: 300, scale: 0.833 },
  // only a key-word style's big word uses it (not in the Font row)
  { key: 'montitalic', label: 'Montserrat Italic', css: 'Montserrat, system-ui, sans-serif', weight: 900, italic: true, scale: 0.64, hidden: true },
];

/** The preview's caption fonts (the worker has the same ones as files). */
export const CAPTION_FONTS_CSS = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;700;900'
  + '&family=Roboto+Condensed:wght@700&family=Noto+Serif:wght@700&family=Montserrat:ital,wght@0,900;1,900'
  + '&family=Poppins:wght@900&family=Anton&family=Bebas+Neue&family=Bangers&family=Luckiest+Guy'
  + '&family=Permanent+Marker&family=Playfair+Display:ital,wght@1,800&family=IBM+Plex+Mono:wght@600&display=swap';

/** How the spoken word looks — the worker's caption_fx WORD_HIGHLIGHTS. */
export const CAPTION_HIGHLIGHTS = [
  { key: 'color', label: 'Color' },
  { key: 'box', label: 'Word box' },
  { key: 'pop', label: 'Pop' },
  { key: 'fill', label: 'Karaoke' },
  { key: 'glow', label: 'Glow' },
  { key: 'underline', label: 'Underline' },
  { key: 'wiggle', label: 'Wiggle' },
];

/** How words come on screen — caption_fx REVEALS. */
export const CAPTION_REVEALS = [
  { key: 'all', label: 'All at once' },
  { key: 'typewriter', label: 'One by one' },
  { key: 'slide', label: 'Slide up' },
  { key: 'fade', label: 'Fade in' },
];

/** What hops onto each word as it starts — caption_fx BOUNCES (the preview plays it). */
export const CAPTION_BOUNCES = [
  { key: 'none', label: 'None' },
  { key: 'ball', label: 'Ball' },
  { key: 'cherry', label: 'Cherry' },
  { key: 'cherryball', label: 'Cherry ball' },
];

/** Burned captions drawn on an upscaled frame (tasks.sharp_frame): crisp on a low-res video. */
export const CAPTION_RES = [
  { key: 'hd', label: 'HD', detail: 'HD captions' },
  { key: '4k', label: '4K', detail: '4K captions' },
];

/** transcript/transitions.py — the start effect and the join between stitched clips. */
export const INTROS = [
  { key: 'none', label: 'None' },
  { key: 'whoosh', label: 'Whoosh' },
  { key: 'zoom', label: 'Zoom in' },
  { key: 'fade', label: 'Fade in' },
  { key: 'flash', label: 'Flash' },
];
// `short` = the chip between two picks (a transition per join)
export const TRANSITIONS = [
  { key: 'none', label: 'Cut', short: 'Cut' },
  { key: 'crossfade', label: 'Crossfade', short: 'Fade' },
  { key: 'black', label: 'Dip to black', short: 'Black' },
  { key: 'flash', label: 'Flash', short: 'Flash' },
  { key: 'slide', label: 'Slide', short: 'Slide' },
  { key: 'smooth', label: 'Smooth slide', short: 'Smooth' },
  { key: 'wipe', label: 'Wipe', short: 'Wipe' },
  { key: 'zoom', label: 'Zoom', short: 'Zoom' },
  { key: 'blur', label: 'Blur', short: 'Blur' },
  { key: 'circle', label: 'Circle', short: 'Circle' },
  { key: 'pixel', label: 'Pixelate', short: 'Pixel' },
];

/** How the letters stand off the picture — the worker's CAPTION_LOOKS. */
export const CAPTION_LOOKS = [
  { key: 'outline', label: 'Outline' },
  { key: 'thick', label: 'Thick' },
  { key: 'box', label: 'Box' },
  { key: 'shadow', label: 'Shadow' },
];

/** XS…XL → the caption_size the worker takes (64 = the old default). */
export const CAPTION_SIZES = [
  { key: 'XS', size: 40 },
  { key: 'S', size: 48 },
  { key: 'M', size: 64 },
  { key: 'L', size: 84 },
  { key: 'XL', size: 108 },
];

export const NO_CAPTIONS = 'no captions';
